import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import SchedulingCalendar from "./SchedulingCalendar";

const BookingDialog = ({ trigger, open, onOpenChange }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    {trigger ? <DialogTrigger asChild>{trigger}</DialogTrigger> : null}
    <DialogContent
      data-testid="booking-dialog"
      className="w-[calc(100%-2rem)] max-w-4xl max-h-[92vh] overflow-y-auto bg-paper border-line rounded-none p-4 md:p-6 gap-0"
    >
      <DialogTitle className="font-serif text-2xl md:text-3xl font-light tracking-tight mb-4">
        Pick a time that <em className="text-taupe">works for you.</em>
      </DialogTitle>
      <SchedulingCalendar />
    </DialogContent>
  </Dialog>
);

export default BookingDialog;
